'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    listboxClassNames: function() {
        return listboxClassNames;
    },
    useListboxStyles_unstable: function() {
        return useListboxStyles_unstable;
    }
});
const _react = require("@griffel/react");
const listboxClassNames = {
    root: 'fui-Listbox'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        De3pzq: "fxugw4r",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Bf4jedk: "f3hsy1e",
        Bmxbyg5: "f5zp4f",
        Bw0xxkn: 0,
        oeaueh: 0,
        Bpd4iqm: 0,
        Befb4lg: "f1iepc6i",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1t35pdg",
        Belr9w4: "fiut8dr"
    }
}, {
    d: [
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f3hsy1e{min-width:160px;}",
        ".f5zp4f{overflow-y:auto;}",
        [
            ".f1iepc6i{outline:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".f1t35pdg{padding:var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".fiut8dr{row-gap:var(--spacingHorizontalXXS);}"
    ]
});
const useListboxStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(listboxClassNames.root, styles.root, state.root.className);
    return state;
};
